<template>
    <div class="main-sale-invoice-wrapper" v-if="mobileCheck">
        <div class="no-data" v-if="!saleOrdersLength">{{ $t('no-sale-orders') }}</div>
        <div v-else>
            <div v-if="!showInvoice">
                <div class="mobile-wines-header">
                    <div>Order No.</div>
                    <div>Date</div>
                    <div>{{ $t('buy13') }}</div>
                    <div>Total excl. VAT</div>
                    <div>{{ $t('invoice05') }}</div>
                    <div>Total incl. VAT</div>
                    <div>Status</div>
                </div>
                <div class="mobile-wines-body">
                    <div class="mobile-wines-row" v-for="(item, index) in filteredItems" :key="index">
                        <div class="mobile-wines-div" v-on:click="() => { goToInvoiceDetails(item) }">
                            <div class="hyperlink-td">
                                {{item.id}}
                                <div class="link-border"></div>
                            </div>
                        </div>
                        <div class="mobile-wines-div">
                            {{item.date}}
                        </div>
                        <div class="mobile-wines-div">
                            {{item.commission}}
                        </div>
                        <div class="mobile-wines-div">
                            {{item.totalExclVat}}
                        </div>
                        <div class="mobile-wines-div">
                            {{item.vat}}
                        </div>
                        <div class="mobile-wines-div">
                            {{item.total}}
                        </div>
                        <div class="mobile-wines-div">
                            {{item.status}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="invoice-details-wrapper" v-else>
                <h2>{{`Sale order No. ${invoiceDetails.invoice.id}`}}</h2>
                <div class="back-invoice" v-on:click="onBackInvoiceHandler">
                    <div>{{ $t('back') }}</div>
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                        <path d="M0 0h24v24H0z" fill="none"/>
                        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
                    </svg>
                </div>
                <v-card header-tag="header">
                    <v-container fluid class="container-invoice" v-if="invoiceDetails.invoiceType === 1">
                        <div class="header-part"></div>
                        <div class="logo"></div>
                        <div class="header-info">
                            <div class="header-info-left">
                                <div class="header-info-row"><span>SALE ORDER</span></div>
                                <div class="header-info-row"><span>Client ID:</span> {{invoiceDetails.invoice.userId}}
                                </div>
                                <div class="header-info-row"><span>Invoice #:</span>
                                    {{invoiceDetails.invoice.userId}}-SO-{{invoiceDetails.invoice.id}}
                                </div>
                                <div class="header-info-row"><span>Invoice date:</span> {{
                                    formatInvoiceDate(invoiceDetails.invoice.createdOn) }}
                                </div>
                                <div class="header-info-row"><span>Invoice period:</span> {{
                                    formatInvoiceDate(invoiceDetails.invoice.createdOn, true) }}
                                </div>
                                <div class="header-info-row"><span>Page:</span> 1/1</div>
                            </div>
                            <div class="header-info-right">
                                <div class="header-info-row" v-if="invoiceDetails.address.company">{{invoiceDetails.address.company}}</div>
                                <div class="header-info-row">{{invoiceDetails.address.clientName}}</div>
                                <div class="header-info-row">{{invoiceDetails.address.address1}}</div>
                                <div class="header-info-row" v-if="invoiceDetails.address.address2">
                                    {{invoiceDetails.address.address2}}
                                </div>
                                <div class="header-info-row">{{invoiceDetails.address.postCode}},
                                    {{invoiceDetails.address.city}}
                                </div>
                                <div class="header-info-row">{{invoiceDetails.address.country}}</div>

                                <div class="header-info-row vat"><strong>Vat Number:</strong>
                                    {{invoiceDetails.address.vatNumber}}
                                </div>
                                <div class="header-info-row"><strong>Email:</strong> {{ invoiceDetails.address.email }}
                                </div>
                                <div class="header-info-row"><strong>{{ $t('myprofile4') }}:</strong>
                                    {{invoiceDetails.address.phoneNumber}}
                                </div>
                            </div>
                        </div>
                        <div class="table-wrapper">
                            <div class="table-header">
                                <div class="th th-first">Item description</div>
                                <div class="th">Size</div>
                                <div class="th">Alcohol %</div>
                                <div class="th">Quantity</div>
                                <div class="th">Unit Amount</div>
                                <div class="th">Total Amount</div>
                            </div>
                            <div class="table-row" v-for="item in invoiceDetails.wines" :key="item.id">
                                <div
                                    :class="{'tr tr-first': item.caseSize === 'n/a' || (item.caseSize !== 'n/a' && item.amount !== null), 'tr-first-wine': item.caseSize === 'n/a', 'tr tr-first tr-first-wine-col': item.caseSize !== 'n/a' && item.amount === null}">
                                    {{item.description}}
                                </div>
                                <div class="tr">{{item.caseSize}}{{item.caseSize === 'n/a' ? '' : 'l'}}</div>
                                <div class="tr">{{item.alcoholDegree}}{{item.alcoholDegree === null ? 'n/a' : '%'}}
                                </div>
                                <div class="tr">{{item.quantity}}</div>
                                <div class="tr" v-if="item.caseSize === 'n/a' || item.amount !== null">&euro;{{(item.amount
                                    / item.quantity).toFixed(2)}}
                                </div>
                                <div class="tr" v-if="item.caseSize === 'n/a' || item.amount !== null">&euro;{{item.amount
                                    ? item.amount.toFixed(2) : '-'}}
                                </div>
                            </div>
                        </div>
                        <div class="subtotal-row no-margin-bottom">Amount excl. VAT: <span>&euro;{{invoiceDetails.invoice.subtotalWines.toFixed(2)}}</span>
                        </div>
                        <div class="subtotal-row no-margin-bottom no-margin-top">VAT Amount(0%): &euro;0.00</div>
                        <div class="subtotal-row no-margin-top">Total Products Amount: <span>&euro;{{invoiceDetails.invoice.subtotalWines.toFixed(2)}}</span>
                        </div>
                        <div class="table-wrapper table-wrapper2">
                            <div class="table-header">
                                <div class="th th-first">Services Charges</div>
                                <div class="th">Amount excl. VAT</div>
                                <div class="th">VAT %</div>
                                <div class="th">VAT Amount</div>
                                <div class="th">Amount incl. VAT</div>
                            </div>
                            <div class="table-row" v-if="!isCollection">
                                <div class="tr tr-first">{{ $t('buy13') }}</div>
                                <div class="tr">&euro;{{invoiceDetails.costs[0].commissionAmountExclVAT.toFixed(2)}}
                                </div>
                                <div class="tr">{{invoiceDetails.costs[0].commissionVATPercentage.toFixed(2)}}%</div>
                                <div class="tr">&euro;{{invoiceDetails.costs[0].commissionVATAmount.toFixed(2)}}</div>
                                <div class="tr">&euro;{{invoiceDetails.costs[0].commissionAmountInclVAT.toFixed(2)}}
                                </div>
                            </div>
                            <div class="table-row">
                                <div class="tr tr-first">Storage (Until
                                    {{formatInvoiceDate(invoiceDetails.costs[0].storageUntil.split(' ')[0])}})
                                </div>
                                <div class="tr">&euro;{{invoiceDetails.costs[0].storageAmountExclVAT.toFixed(2)}}</div>
                                <div class="tr">{{invoiceDetails.costs[0].storageVATPercentage.toFixed(2)}}%</div>
                                <div class="tr">&euro;{{invoiceDetails.costs[0].storageVATAmount.toFixed(2)}}</div>
                                <div class="tr">&euro;{{invoiceDetails.costs[0].storageAmountInclVAT.toFixed(2)}}</div>
                            </div>
                            <div class="table-row">
                                <div class="tr tr-first">Insurance (Until
                                    {{formatInvoiceDate(invoiceDetails.costs[0].storageUntil.split(' ')[0])}})
                                </div>
                                <div class="tr">&euro;{{invoiceDetails.costs[0].insuranceAmountExclVAT.toFixed(2)}}
                                </div>
                                <div class="tr">{{invoiceDetails.costs[0].insuranceVATPercentage.toFixed(2)}}%</div>
                                <div class="tr">&euro;{{invoiceDetails.costs[0].insuranceVATAmount.toFixed(2)}}</div>
                                <div class="tr">&euro;{{invoiceDetails.costs[0].insuranceAmountInclVAT.toFixed(2)}}
                                </div>
                            </div>
                            <div class="table-row">
                                <div class="tr tr-first tr-first-wine">Total Services Charges</div>
                                <div class="tr">&euro;{{invoiceDetails.invoice.subtotalCostsAmountExclVAT.toFixed(2)}}
                                </div>
                                <div class="tr">&nbsp;</div>
                                <div class="tr">&euro;{{invoiceDetails.invoice.subtotalCostsVATAmount.toFixed(2)}}</div>
                                <div class="tr">&euro;{{invoiceDetails.invoice.subtotalCostsAmountInclVAT.toFixed(2)}}
                                </div>
                            </div>
                        </div>

                        <div class="subtotal-row no-margin-bottom">Amount excl. VAT: <span>&euro;{{(invoiceDetails.invoice.subtotalWines + invoiceDetails.costs[0].commissionAmountExclVAT + invoiceDetails.costs[0].storageAmountExclVAT + invoiceDetails.costs[0].insuranceAmountExclVAT).toFixed(2)}}</span>
                        </div>
                        <div class="subtotal-row no-margin-bottom">VAT amount: <span>&euro;{{invoiceDetails.invoice.subtotalCostsVATAmount.toFixed(2)}}</span>
                        </div>
                        <div class="subtotal-row2">Total invoice amount: <span>&euro;{{invoiceDetails.invoice.totalInvoiceAmount.toFixed(2)}}</span>
                        </div>

                        <div class="monthly-details" v-if="isCollection">
                            <div>* Storage amount per case per month € 0.99</div>
                            <div>** Insurance % on value of wine per month 0.04%</div>
                            <div>*** Min monthly insurance fee per case € 0.10</div>
                        </div>
                        <div class="monthly-details" v-else>
                            <div>* Commission 4%</div>
                            <div>** Storage amount per case per month € 0.99</div>
                            <div>*** Insurance % on value of wine per month 0.04%</div>
                            <div>**** Min monthly insurance fee per case € 0.10</div>
                        </div>

                        <div class="vat-info">Marchandises a destination de 'JF Hillebrand' sous régime suspensif RFS n
                            FR D-61 1032 du 15 Juillet 2013.<br>Vente en Suspension de TVA au titre de l`Articel 227 A
                            du CGI
                        </div>
                        <div class="footer">
                            <div class="footer-left">
                                <div class="footer-row footer-bold">{{ companyAddress1 }}</div>
                                <div class="footer-row">{{companyAddress}}</div>
                                <div class="footer-row">{{ companyAddress2 }}</div>
                            </div>
                            <div class="footer-right">
                                <div class="footer-row">www.vindome.net</div>
                            </div>
                        </div>
                    </v-container>
                    <v-container fluid class="container-invoice" v-else>
                        <div class="header-part"></div>
                        <div class="logo"></div>
                        <div class="header-info">
                            <div class="header-info-left">
                                <div class="header-info-row"><span>SALE ORDER</span></div>
                                <div class="header-info-row"><span>Client ID:</span> {{invoiceDetails.invoice.userId}}
                                </div>
                                <div class="header-info-row"><span>Invoice #:</span>
                                    {{invoiceDetails.invoice.userId}}-SO-{{invoiceDetails.invoice.id}}
                                </div>
                                <div class="header-info-row"><span>Sale order Date:</span> {{
                                    formatInvoiceDate(invoiceDetails.invoice.createdOn) }}
                                </div>
                                <div class="header-info-row"><span>Reference Number:</span> {{
                                    invoiceDetails.invoice.sogenId || "-" }}
                                </div>
                                <div class="header-info-row"><span>Page:</span> 1/1</div>
                            </div>
                            <div class="header-info-right">
                                <div class="header-info-row" v-if="invoiceDetails.address.company">{{invoiceDetails.address.company}}</div>
                                <div class="header-info-row">{{invoiceDetails.address.clientName}}</div>
                                <div class="header-info-row">{{invoiceDetails.address.address1}}</div>
                                <div class="header-info-row" v-if="invoiceDetails.address.address2">
                                    {{invoiceDetails.address.address2}}
                                </div>
                                <div class="header-info-row">{{invoiceDetails.address.postCode}},
                                    {{invoiceDetails.address.city}}
                                </div>
                                <div class="header-info-row">{{invoiceDetails.address.country}}</div>

                                <div class="header-info-row vat"><strong>Vat Number:</strong>
                                    {{invoiceDetails.address.vatNumber || '-'}}
                                </div>
                                <div class="header-info-row"><strong>Email:</strong> {{invoiceDetails.address.email}}
                                </div>
                                <div class="header-info-row"><strong>{{ $t('myprofile4') }}:</strong>
                                    {{invoiceDetails.address.phoneNumber}}
                                </div>
                            </div>
                        </div>
                        <div class="table-wrapper table-wrapper-monthly">
                            <div class="table-header">
                                <div class="th th-first th-first-monthly">Item description</div>
                                <div class="th">Size</div>
                                <div class="th">Alc.%</div>
                                <div class="th">Quantity</div>
                                <div class="th">Amount</div>
                            </div>
                            <div class="table-row table-row-details" v-for="item in invoiceDetails.wines"
                                 :key="item.id">
                                <div class="tr tr-first-monthly">{{item.description}}</div>
                                <div class="tr">{{ item.caseSize === 'n/a' ? '-' : `${item.caseSize}l` }}</div>
                                <div class="tr">{{item.alcoholDegree }}</div>
                                <div class="tr">{{item.quantity }}</div>
                                <div class="tr">{{item.amount ? formatPrice(item.amount.toLocaleString("fi-FI", {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) : '-'}}
                                </div>
                            </div>

                            <div class="table-row mobile-bold">
                                <div class="tr">Amount excl. VAT:</div>
                                <div class="tr">&euro;{{subtotal.toFixed(2)}}</div>
                            </div>
                        </div>

                        <div class="table-wrapper table-wrapper3">
                            <div class="table-header">
                                <div class="th th-first">Services Charges</div>
                                <div class="th">Amount excl. VAT</div>
                                <div class="th">VAT %</div>
                                <div class="th">VAT amount</div>
                                <div class="th">Amount incl. VAT</div>
                            </div>
                            <div class="table-row">
                                <div class="tr tr-first">{{ $t('buy13') }}</div>
                                <div class="tr">- &euro;{{costDesc.commissionAmountExclVAT.toFixed(2)}}</div>
                                <div class="tr">{{costDesc.commissionVATPercentage}}%</div>
                                <div class="tr">- &euro;{{costDesc.commissionVATAmount.toFixed(2)}}</div>
                                <div class="tr">- &euro;{{costDesc.commissionAmountInclVAT.toFixed(2)}}</div>
                            </div>
                        </div>
                        <div class="subtotal-row3">Total Invoice Amount excl. VAT: <span>&euro;{{(invoiceDetails.invoice.subtotalWines + invoiceDetails.invoice.subtotalCostsAmountExclVAT).toFixed(2)}}</span>
                        </div>
                        <div class="subtotal-row3">Total Invoice VAT Amount: <span>- &euro;{{invoiceDetails.costs[0].commissionVATAmount.toFixed(2)}}</span>
                        </div>

                        <div class="subtotal-row2">Total invoice amount: <span>&euro;{{total.toFixed(2)}}</span></div>
                        <div class="monthly-details">
                            <div>* Commission (4%)</div>
                        </div>
                        <div class="vat-info">Marchandises a destination de 'JF Hillebrand' sous régime suspensif RFS n
                            FR D-61 1032 du 15 Juillet 2013.<br>Vente en Suspension de TVA au titre de l`Articel 227 A
                            du CGI
                        </div>
                        <div class="footer">
                            <div class="footer-left">
                                <div class="footer-row footer-bold">{{ companyAddress1 }}</div>
                                <div class="footer-row">{{companyAddress}}</div>
                                <div class="footer-row">{{ companyAddress2 }}</div>
                            </div>
                            <div class="footer-right">
                                <div class="footer-row">www.vindome.net</div>
                            </div>
                        </div>
                    </v-container>
                </v-card>
                <div class="download-pdf" v-on:click="downloadInvoicePDF">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                        <path d="M0 0h24v24H0z" fill="none"/>
                        <path
                            d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"/>
                    </svg>
                    Download
                </div>
            </div>
        </div>
    </div>
    <div class="main-sale-invoice-wrapper" v-else>
        <h2>{{showInvoice && saleOrdersLength ? `Sale order No. ${invoiceDetails.invoice.id}` :
            $t('my-account-menu10')}}</h2>
        <div class="no-data" v-if="!saleOrdersLength">{{ $t('no-sale-orders') }}</div>
        <div v-else>
            <v-data-table v-if="!showInvoice" :headers="headers" :items="filteredItems" :items-per-page="50"
                          hide-default-footer fixed-header class="default-table custom-table">
                <template v-slot:item="{ item }">
                    <tr>
                        <td v-on:click="() => { goToInvoiceDetails(item) }">
                            <div class="hyperlink-td">
                                {{item.id}}
                                <div class="link-border"></div>
                            </div>
                        </td>
                        <td>
                            {{ formatDate(item.date) }}
                        </td>
                        <td class="text-right">
                            {{item.commission}}
                        </td>
                        <td class="text-right">
                            {{item.totalExclVat}}
                        </td>
                        <td class="text-right">
                            {{item.vat}}
                        </td>
                        <td class="text-right">
                            {{item.total}}
                        </td>
                        <td class="text-right">
                            {{item.status}}
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <div class="invoice-details-wrapper" v-else>
                <div class="back-invoice" v-on:click="onBackInvoiceHandler">
                    <div>{{ $t('back') }}</div>
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                        <path d="M0 0h24v24H0z" fill="none"/>
                        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
                    </svg>
                </div>
                <v-card header-tag="header">
                    <v-container fluid class="container-invoice" v-if="invoiceDetails.invoiceType === 1">
                        <div class="header-part"></div>
                        <div class="logo"></div>
                        <div class="header-info">
                            <div class="header-info-left">
                                <div class="header-info-row"><span>SALE ORDER</span></div>
                                <div class="header-info-row"><span>Client ID:</span> {{invoiceDetails.invoice.userId}}
                                </div>
                                <div class="header-info-row"><span>Invoice #:</span>
                                    {{invoiceDetails.invoice.userId}}-SO-{{invoiceDetails.invoice.id}}
                                </div>
                                <div class="header-info-row"><span>Invoice date:</span> {{
                                    formatInvoiceDate(invoiceDetails.invoice.createdOn) }}
                                </div>
                                <div class="header-info-row"><span>Invoice period:</span> {{
                                    formatInvoiceDate(invoiceDetails.invoice.createdOn, true) }}
                                </div>
                                <div class="header-info-row"><span>Page:</span> 1/1</div>
                            </div>
                            <div class="header-info-right">
                                <div class="header-info-row" v-if="invoiceDetails.address.company">{{invoiceDetails.address.company}}</div>
                                <div class="header-info-row">{{invoiceDetails.address.clientName}}</div>
                                <div class="header-info-row">{{invoiceDetails.address.address1}}</div>
                                <div class="header-info-row" v-if="invoiceDetails.address.address2">
                                    {{invoiceDetails.address.address2}}
                                </div>
                                <div class="header-info-row">{{invoiceDetails.address.postCode}},
                                    {{invoiceDetails.address.city}}
                                </div>
                                <div class="header-info-row">{{invoiceDetails.address.country}}</div>

                                <div class="header-info-row vat"><strong>Vat Number:</strong>
                                    {{invoiceDetails.address.vatNumber}}
                                </div>
                                <div class="header-info-row"><strong>Email:</strong> {{ invoiceDetails.address.email }}
                                </div>
                                <div class="header-info-row"><strong>{{ $t('myprofile4') }}:</strong>
                                    {{invoiceDetails.address.phoneNumber}}
                                </div>
                            </div>
                        </div>
                        <div class="table-wrapper">
                            <div class="table-header">
                                <div class="th th-first">Item description</div>
                                <div class="th">Size</div>
                                <div class="th">Alcohol %</div>
                                <div class="th">Quantity</div>
                                <div class="th">Unit Amount</div>
                                <div class="th">Total Amount</div>
                            </div>
                            <div class="table-row" v-for="item in invoiceDetails.wines" :key="item.id">
                                <div
                                    :class="{'tr tr-first': item.caseSize === 'n/a' || (item.caseSize !== 'n/a' && item.amount !== null), 'tr-first-wine': item.caseSize === 'n/a', 'tr tr-first tr-first-wine-col': item.caseSize !== 'n/a' && item.amount === null}">
                                    {{item.description}}
                                </div>
                                <div class="tr">{{item.caseSize}}{{item.caseSize === 'n/a' ? '' : 'l'}}</div>
                                <div class="tr">{{item.alcoholDegree}}{{item.alcoholDegree === null ? 'n/a' : '%'}}
                                </div>
                                <div class="tr">{{item.quantity}}</div>
                                <div class="tr" v-if="item.caseSize === 'n/a' || item.amount !== null">&euro;{{(item.amount
                                    / item.quantity).toFixed(2)}}
                                </div>
                                <div class="tr" v-if="item.caseSize === 'n/a' || item.amount !== null">&euro;{{item.amount
                                    ? item.amount.toFixed(2) : '-'}}
                                </div>
                            </div>
                        </div>
                        <div class="subtotal-row no-margin-bottom">Amount excl. VAT: <span>&euro;{{invoiceDetails.invoice.subtotalWines.toFixed(2)}}</span>
                        </div>
                        <div class="subtotal-row no-margin-bottom no-margin-top">VAT Amount(0%): &euro;0.00</div>
                        <div class="subtotal-row no-margin-top">Total Products Amount: <span>&euro;{{invoiceDetails.invoice.subtotalWines.toFixed(2)}}</span>
                        </div>
                        <div class="table-wrapper table-wrapper2">
                            <div class="table-header">
                                <div class="th th-first">Services Charges</div>
                                <div class="th">Amount excl. VAT</div>
                                <div class="th">VAT %</div>
                                <div class="th">VAT Amount</div>
                                <div class="th">Amount incl. VAT</div>
                            </div>
                            <div class="table-row" v-if="!isCollection">
                                <div class="tr tr-first">{{ $t('buy13') }}</div>
                                <div class="tr">&euro;{{invoiceDetails.costs[0].commissionAmountExclVAT.toFixed(2)}}
                                </div>
                                <div class="tr">{{invoiceDetails.costs[0].commissionVATPercentage.toFixed(2)}}%</div>
                                <div class="tr">&euro;{{invoiceDetails.costs[0].commissionVATAmount.toFixed(2)}}</div>
                                <div class="tr">&euro;{{invoiceDetails.costs[0].commissionAmountInclVAT.toFixed(2)}}
                                </div>
                            </div>
                            <div class="table-row">
                                <div class="tr tr-first">Storage (Until
                                    {{formatInvoiceDate(invoiceDetails.costs[0].storageUntil.split(' ')[0])}})
                                </div>
                                <div class="tr">&euro;{{invoiceDetails.costs[0].storageAmountExclVAT.toFixed(2)}}</div>
                                <div class="tr">{{invoiceDetails.costs[0].storageVATPercentage.toFixed(2)}}%</div>
                                <div class="tr">&euro;{{invoiceDetails.costs[0].storageVATAmount.toFixed(2)}}</div>
                                <div class="tr">&euro;{{invoiceDetails.costs[0].storageAmountInclVAT.toFixed(2)}}</div>
                            </div>
                            <div class="table-row">
                                <div class="tr tr-first">Insurance (Until
                                    {{formatInvoiceDate(invoiceDetails.costs[0].storageUntil.split(' ')[0])}})
                                </div>
                                <div class="tr">&euro;{{invoiceDetails.costs[0].insuranceAmountExclVAT.toFixed(2)}}
                                </div>
                                <div class="tr">{{invoiceDetails.costs[0].insuranceVATPercentage.toFixed(2)}}%</div>
                                <div class="tr">&euro;{{invoiceDetails.costs[0].insuranceVATAmount.toFixed(2)}}</div>
                                <div class="tr">&euro;{{invoiceDetails.costs[0].insuranceAmountInclVAT.toFixed(2)}}
                                </div>
                            </div>
                            <div class="table-row">
                                <div class="tr tr-first tr-first-wine">Total Services Charges</div>
                                <div class="tr">&euro;{{invoiceDetails.invoice.subtotalCostsAmountExclVAT.toFixed(2)}}
                                </div>
                                <div class="tr">&nbsp;</div>
                                <div class="tr">&euro;{{invoiceDetails.invoice.subtotalCostsVATAmount.toFixed(2)}}</div>
                                <div class="tr">&euro;{{invoiceDetails.invoice.subtotalCostsAmountInclVAT.toFixed(2)}}
                                </div>
                            </div>
                        </div>

                        <div class="subtotal-row no-margin-bottom">Amount excl. VAT: <span>&euro;{{(invoiceDetails.invoice.subtotalWines + invoiceDetails.costs[0].commissionAmountExclVAT + invoiceDetails.costs[0].storageAmountExclVAT + invoiceDetails.costs[0].insuranceAmountExclVAT).toFixed(2)}}</span>
                        </div>
                        <div class="subtotal-row no-margin-bottom">VAT amount: <span>&euro;{{invoiceDetails.invoice.subtotalCostsVATAmount.toFixed(2)}}</span>
                        </div>
                        <div class="subtotal-row2">Total invoice amount: <span>&euro;{{invoiceDetails.invoice.totalInvoiceAmount.toFixed(2)}}</span>
                        </div>

                        <div class="monthly-details" v-if="isCollection">
                            <div>* Storage amount per case per month € 0.99</div>
                            <div>** Insurance % on value of wine per month 0.04%</div>
                            <div>*** Min monthly insurance fee per case € 0.10</div>
                        </div>
                        <div class="monthly-details" v-else>
                            <div>* Commission 4%</div>
                            <div>** Storage amount per case per month € 0.99</div>
                            <div>*** Insurance % on value of wine per month 0.04%</div>
                            <div>**** Min monthly insurance fee per case € 0.10</div>
                        </div>

                        <div class="vat-info">Marchandises a destination de 'JF Hillebrand' sous régime suspensif RFS n
                            FR D-61 1032 du 15 Juillet 2013.<br>Vente en Suspension de TVA au titre de l`Articel 227 A
                            du CGI
                        </div>
                        <div class="footer">
                            <div class="footer-left">
                                <div class="footer-row footer-bold">{{ companyAddress1 }}</div>
                                <div class="footer-row">{{companyAddress}}</div>
                                <div class="footer-row">{{ companyAddress2 }}</div>
                            </div>
                            <div class="footer-right">
                                <div class="footer-row">www.vindome.net</div>
                            </div>
                        </div>
                    </v-container>
                    <v-container fluid class="container-invoice" v-else>
                        <div class="header-part"></div>
                        <div class="logo"></div>
                        <div class="header-info">
                            <div class="header-info-left">
                                <div class="header-info-row"><span>SALE ORDER</span></div>
                                <div class="header-info-row"><span>Client ID:</span> {{invoiceDetails.invoice.userId}}
                                </div>
                                <div class="header-info-row"><span>Invoice #:</span>
                                    {{invoiceDetails.invoice.userId}}-SO-{{invoiceDetails.invoice.id}}
                                </div>
                                <div class="header-info-row"><span>Sale order Date:</span> {{
                                    formatInvoiceDate(invoiceDetails.invoice.createdOn) }}
                                </div>
                                <div class="header-info-row"><span>Reference Number:</span> {{
                                    invoiceDetails.invoice.sogenId || "-" }}
                                </div>
                                <div class="header-info-row"><span>Page:</span> 1/1</div>
                            </div>
                            <div class="header-info-right">
                                <div class="header-info-row" v-if="invoiceDetails.address.company">{{invoiceDetails.address.company}}</div>
                                <div class="header-info-row">{{invoiceDetails.address.clientName}}</div>
                                <div class="header-info-row">{{invoiceDetails.address.address1}}</div>
                                <div class="header-info-row" v-if="invoiceDetails.address.address2">
                                    {{invoiceDetails.address.address2}}
                                </div>
                                <div class="header-info-row">{{invoiceDetails.address.postCode}},
                                    {{invoiceDetails.address.city}}
                                </div>
                                <div class="header-info-row">{{invoiceDetails.address.country}}</div>

                                <div class="header-info-row vat"><strong>Vat Number:</strong>
                                    {{invoiceDetails.address.vatNumber || '-'}}
                                </div>
                                <div class="header-info-row"><strong>Email:</strong> {{invoiceDetails.address.email}}
                                </div>
                                <div class="header-info-row"><strong>{{ $t('myprofile4') }}:</strong>
                                    {{invoiceDetails.address.phoneNumber}}
                                </div>
                            </div>
                        </div>
                        <div class="table-wrapper table-wrapper-monthly">
                            <div class="table-header">
                                <div class="th th-first th-first-monthly">Item description</div>
                                <div class="th">Size</div>
                                <div class="th">Alc.%</div>
                                <div class="th">Quantity</div>
                                <div class="th">Amount</div>
                            </div>
                            <div class="table-row table-row-details" v-for="item in invoiceDetails.wines"
                                 :key="item.id">
                                <div class="tr tr-first-monthly">{{item.description}}</div>
                                <div class="tr">{{ item.caseSize === 'n/a' ? '-' : `${item.caseSize}l` }}</div>
                                <div class="tr">{{item.alcoholDegree }}</div>
                                <div class="tr">{{item.quantity }}</div>
                                <div class="tr">{{item.amount ? formatPrice(item.amount.toLocaleString("fi-FI", {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) : '-'}}
                                </div>
                            </div>

                            <div class="table-row">
                                <div class="tr tr-first tr-first-monthly">&nbsp;</div>
                                <div class="tr">&nbsp;</div>
                                <div class="tr">&nbsp;</div>
                                <div class="tr">Amount excl. VAT:</div>
                                <div class="tr">&euro;{{invoiceDetails.invoice.subtotalWines.toFixed(2)}}</div>
                            </div>
                        </div>

                        <div class="table-wrapper table-wrapper3">
                            <div class="table-header">
                                <div class="th th-first">Services Charges</div>
                                <div class="th">Amount excl. VAT</div>
                                <div class="th">VAT %</div>
                                <div class="th">VAT amount</div>
                                <div class="th">Amount incl. VAT</div>
                            </div>
                            <div class="table-row">
                                <div class="tr tr-first">{{ $t('buy13') }}</div>
                                <div class="tr">- &euro;{{costDesc.commissionAmountExclVAT.toFixed(2)}}</div>
                                <div class="tr">{{costDesc.commissionVATPercentage}}%</div>
                                <div class="tr">- &euro;{{costDesc.commissionVATAmount.toFixed(2)}}</div>
                                <div class="tr">- &euro;{{costDesc.commissionAmountInclVAT.toFixed(2)}}</div>
                            </div>
                        </div>
                        <div class="subtotal-row3">Total Invoice Amount excl. VAT: <span>&euro;{{(invoiceDetails.invoice.subtotalWines + invoiceDetails.invoice.subtotalCostsAmountExclVAT).toFixed(2)}}</span>
                        </div>
                        <div class="subtotal-row3">Total Invoice VAT Amount: <span>- &euro;{{invoiceDetails.costs[0].commissionVATAmount.toFixed(2)}}</span>
                        </div>

                        <div class="subtotal-row2">Total invoice amount: <span>&euro;{{invoiceDetails.invoice.totalInvoiceAmount.toFixed(2)}}</span>
                        </div>
                        <div class="monthly-details">
                            <div>* Commission (4%)</div>
                        </div>
                        <div class="vat-info">Marchandises a destination de 'JF Hillebrand' sous régime suspensif RFS n
                            FR D-61 1032 du 15 Juillet 2013.<br>Vente en Suspension de TVA au titre de l`Articel 227 A
                            du CGI
                        </div>
                        <div class="footer">
                            <div class="footer-left">
                                <div class="footer-row footer-bold">{{ companyAddress1 }}</div>
                                <div class="footer-row">{{companyAddress}}</div>
                                <div class="footer-row">{{ companyAddress2 }}</div>
                            </div>
                            <div class="footer-right">
                                <div class="footer-row">www.vindome.net</div>
                            </div>
                        </div>
                    </v-container>
                </v-card>
                <div class="download-pdf" v-on:click="downloadInvoicePDF">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                        <path d="M0 0h24v24H0z" fill="none"/>
                        <path
                            d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"/>
                    </svg>
                    Download
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {AOrders, AUser} from '../store/actions';
    import {GCommon, GOrders} from '../store/getters';
    import moment from 'moment'

    export default {
        name: "SaleOrders",
        props: ['selectedSaleInvoiceId'],
        data() {
            return {
                orderMatchId: null,
                saleOrderId: 0,
                headers: [
                    {text: 'Order No.', value: 'id', class: 'invoiceNumber-th'},
                    {text: 'Date', value: 'date'},
                    {text: 'Commission', align: 'right', value: 'commission'},
                    {text: 'Total excl. VAT', align: 'right', value: 'totalExclVat'},
                    {text: 'VAT', align: 'right', value: 'vat'},
                    {text: 'Total incl. VAT', align: 'right', value: 'total'},
                    {text: 'Status', align: 'right', value: 'status'}
                ],
                showInvoice: false,
                openedViaSoldWines: false,
                openedViaWinePerformance: false
            };
        },
        computed: {
            ...mapGetters({
                saleOrdersList: GOrders.GET_SALE_ORDERS,
                saleOrdersLength: GOrders.GET_SALE_ORDERS_LENGTH,
                invoiceDetails: GOrders.GET_SALE_ORDER_DETAILS,
                mobileCheck: GCommon.GET_MOBILE_VERSION
            }),
            filteredItems() {
                let updatedListItems = [];

                this.saleOrdersList.forEach(item => {
                    let invoiceItem = {};
                    invoiceItem.id = item.saleOrderNumber;
                    invoiceItem.date = moment(item.saleOrderDate).format('DD MMM YYYY');
                    invoiceItem.commission = this.formatPrice(item.commissionAmountExclVat.toLocaleString("fi-FI", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }).replace(',', '.'));
                    invoiceItem.totalExclVat = this.formatPrice(item.totalExclVat.toLocaleString("fi-FI", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }).replace(',', '.'));
                    invoiceItem.vat = this.formatPrice(item.vat.toLocaleString("fi-FI", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }).replace(',', '.'));
                    invoiceItem.total = this.formatPrice(item.totalInclVat.toLocaleString("fi-FI", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }).replace(',', '.'));
                    invoiceItem.status = item.isPaid ? 'Paid' : 'Not paid'
                    updatedListItems.push(invoiceItem);
                });

                return updatedListItems;
            },
            costDesc() {
                return this.invoiceDetails.costs[0]
            },
            subtotal() {
                let amount = 0;
                this.invoiceDetails.wines.forEach(element => {
                    amount += element.amount
                });
                return amount
            },
            total() {
                return this.subtotal - this.invoiceDetails.costs[0].commissionAmountInclVAT - this.invoiceDetails.costs[0].insuranceAmountInclVAT - this.invoiceDetails.costs[0].storageAmountInclVAT
            },
            companyAddress() {
                let address = '';
                let date1 = new Date(this.invoiceDetails.invoice.createdOn);
                let date2 = new Date('2024-05-15');
                let date3 = new Date('2024-06-25');

                if (date1.getTime() < date2.getTime()) {
                    address = 'Villa Mignon, 1 rue Suffren Reymond, 98000, Monaco'
                } else {
                    if (date1.getTime() < date3.getTime()) {
                        address = '17, Avenue Albert II, L’Albu - 8ème étage, 98000 - Monaco'
                    } else {
                        address = '9 Simeonovsko shose Blvd, 1700 Sofia, Bulgaria'
                    }
                }

                return address
            },
            companyAddress1() {
                let address = '';
                let date1 = new Date(this.invoiceDetails.invoice.createdOn);
                let date2 = new Date('2024-06-25');

                if (date1.getTime() < date2.getTime()) {
                    address = 'Vindome Sarl'
                } else {
                    address = 'Vindome EOOD'
                }

                return address
            },
            companyAddress2() {
                let address = '';
                let date1 = new Date(this.invoiceDetails.invoice.createdOn);
                let date2 = new Date('2024-06-25');

                if (date1.getTime() < date2.getTime()) {
                    address = 'RCI 19S08128 VAT FR38000143213 Capital Social &euro;100,000.00'
                } else {
                    address = 'VAT BG207675664 Capital Social 20,000.00 BGN'
                }

                return address
            }
        },
        methods: {
            onBackInvoiceHandler() {
                if (this.openedViaSoldWines) {
                    this.$emit('triggerBackToSoldWinesPage')
                    this.openedViaSoldWines = false
                } else if (this.openedViaWinePerformance) {
                    this.$router.go(-1)
                    this.openedViaWinePerformance = false
                } else {
                    this.showInvoice = false
                }
            },
            goToInvoiceDetails(invoice) {
                this.$store.dispatch(AOrders.GET_SALE_ORDER_DETAILS, invoice.id).then(() => {
                    this.showInvoice = true
                });
            },
            formatDate(date) {
                return moment(date).locale(this.$i18n.locale).format('DD MMM YYYY')
            },
            formatPrice(price) {
                return `€ ${price}`
            },
            formatInvoiceDate(date, isMonthly) {
                if (isMonthly) {
                    let formattedDate = new Date(date);
                    formattedDate.setDate(1);
                    formattedDate.setMonth(formattedDate.getMonth() - 1);
                    return moment(formattedDate).locale(this.$i18n.locale).format('MMMM YYYY')
                } else {
                    return moment(date).locale(this.$i18n.locale).format('DD MMM YYYY');
                }
            },
            downloadInvoicePDF() {
                this.$store.dispatch(AOrders.GET_SALE_ORDER_PDF, {
                    invoiceId: this.invoiceDetails.invoice.id,
                    userId: this.invoiceDetails.invoice.userId
                })
            }
        },
        created() {
            this.$store.dispatch(AOrders.GET_SALE_ORDERS);
        },
        watch: {
            filteredItems: {
                immediate: true,
                deep: true,
                handler(v) {
                    if (this.filteredItems.length) {
                        if (this.$route.query.id) {
                            this.saleOrderId = this.$route.query.id
                        }

                        if (this.saleOrderId !== 0) {
                            this.goToInvoiceDetails({id: this.saleOrderId})
                            this.openedViaWinePerformance = true;

                            window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: 'smooth'
                            });
                        }
                    }
                }
            },
            selectedSaleInvoiceId: {
                immediate: true,
                deep: true,
                handler(v, o) {
                    if (this.selectedSaleInvoiceId !== 0) {
                        this.goToInvoiceDetails({id: this.selectedSaleInvoiceId})
                        this.openedViaSoldWines = true;

                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .download-pdf {
        display: inline-block;
        height: 32px;
        color: #FFF;
        background-color: var(--blue);
        border: 1px solid var(--blue);
        border-radius: 6px;
        line-height: 30px;
        min-width: 125px;
        text-align: center;
        padding-left: 30px;
        margin-top: 32px;
        margin-bottom: 32px;
        float: right;
        position: relative;
    }

    .download-pdf:hover {
        cursor: pointer;
    }

    .download-pdf svg {
        width: 20px;
        height: 20px;
        position: absolute;
        left: 10px;
        top: 5px;
        color: #FFF;
        fill: #FFF;
    }

    .main-sale-invoice-wrapper h2 {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-weight: 700;
        font-size: 25px;
        line-height: 30px;
        color: #303030;
        margin-top: 43px;
        margin-bottom: 38px;
    }

    .back-invoice {
        position: absolute;
        right: 0;
        top: 0;
        font-size: 16px;
        font-weight: 300;
        color: #b2b2b2;
    }

    .back-invoice svg {
        fill: #b2b2b2;
        margin-left: 5px;
    }

    .back-invoice:hover {
        color: var(--brand);
        cursor: pointer;
    }

    .back-invoice:hover svg {
        fill: var(--brand);
    }

    .header-part {
        background: #03486F url('../assets/header.png') no-repeat center top;
        height: 42px;
        margin-bottom: 30px;
    }

    .logo {
        background: url('../assets/logo_blue.png') no-repeat center;
        width: 282px;
        height: 80px;
        background-size: contain;
    }

    .header-info {
        height: 250px;
        margin: 40px 30px;
    }

    .header-info-left {
        width: 50%;
        display: inline-block;
        vertical-align: top;
    }

    .header-info-right {
        float: right;
        width: 300px;
        text-align: left;
        vertical-align: top;
    }

    .header-info-row {
        font-size: 18px;
        line-height: 25px;
    }

    .header-info-row span,
    .header-info-row strong {
        display: inline-block;
        margin-right: 10px;
        font-weight: 600;
        font-style: normal;
    }

    .header-info-row.vat {
        margin-top: 20px;
    }

    .table-wrapper {
        margin-top: 50px;
    }

    .table-header {
        font-size: 16px;
        font-weight: 600;
        border-bottom: 1px solid #B6B6B6;
        height: 40px;
    }

    .table-row {
        border-bottom: 1px solid #F6F7F7;
        height: 40px;
        line-height: 39px;
    }

    .table-row-details {
        height: 80px;
    }

    .container-invoice {
        width: 100%;
    }

    .th, .tr {
        width: 15%;
        float: left;
        line-height: 39px;
    }

    .th,
    .tr {
        text-align: right;
    }

    .th.th-first,
    .tr.tr-first {
        width: 50%;
        float: left;
        text-align: left;
    }

    .tr-first-wine-col {
        padding-left: 30px;
    }

    .th.th-first-monthly,
    .tr.tr-first-monthly {
        width: 40%;
        white-space: nowrap;
        text-align: left;
    }

    .th.th-reference,
    .tr.tr-reference {
        width: 20%;
        float: left;
    }

    .table-wrapper2 .th.th-first,
    .table-wrapper2 .tr.tr-first {
        width: 60%;
    }

    .table-wrapper3 .th.th-first,
    .table-wrapper3 .tr.tr-first {
        width: 40%;
    }

    .subtotal-row {
        text-align: right;
        font-size: 20px;
        margin: 20px 0;
    }

    .no-margin-bottom {
        margin-bottom: 0;
    }

    .no-margin-top {
        margin-top: 0;
    }

    .subtotal-row2 {
        text-align: right;
        font-size: 25px;
        margin: 35px 0;
    }

    .subtotal-row3 {
        text-align: right;
        font-size: 20px;
        margin: 5px 0;
    }

    .subtotal-row span, .subtotal-row2 span {
        font-weight: 600;
        display: inline-block;
        margin-left: 10px;
    }

    .vat-info {
        margin-top: 150px;
        margin-bottom: 30px;
        text-align: right;
    }

    .footer {
        border-top: 1px solid #B1B1B1;
        padding: 40px 0 20px;
        font-size: 16px;
    }

    .footer-left {
        width: calc(100% - 275px);
        display: inline-block;
    }

    .footer-right {
        width: 270px;
        padding-top: 50px;
        display: inline-block;
        vertical-align: top;
        text-align: right;
    }

    .footer-bold {
        font-weight: 600;
    }

    .footer-row-buy-wine {
        padding: 5px 15px;
        border: 1px solid #02486f;
        color: #02486f;
        margin-bottom: 12px;
        display: inline-block;
    }

    .table-row-desc,
    .tr-first-wine {
        font-weight: bold;
    }

    .mobile-wines-header {
        margin-top: 30px;
        padding: 0 0 10px;
    }

    .mobile-wines-header div {
        color: #b2b2b2 !important;
        font-size: var(--fs-small);
        font-weight: 300;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        height: 20px;
        white-space: nowrap;
        display: inline-block;
        width: 33.33%;
    }

    .mobile-wines-row {
        padding: 15px 0;
        border-top: 1px solid #b2b2b2;
    }

    .mobile-wines-row:nth-child(even) {
        background: var(--semi-white);
    }

    .mobile-wines-div {
        display: inline-block;
        width: 33.33%;
        vertical-align: top;
        padding: 5px 0;
    }

    .mobile-wines-div .hyperlink-td {
        float: left;
    }

    .mobile-wines-div .link-border {
        height: 1px;
        width: 100%;
        background: #707070;
    }

    .invoice-details-wrapper .container-invoice {
        background-color: #FFF;
    }

    @media (max-width: 767px) {
        .container-invoice {
            padding: 0;
        }

        .logo {
            margin: 0 auto;
        }

        .header-info {
            height: auto;
            margin: 15px;
        }

        .header-info-left,
        .header-info-right {
            width: 100%;
            float: none;
        }

        .header-info-right {
            margin-top: 20px;
        }

        .footer-left,
        .footer-right {
            display: block;
            width: 100%;
        }

        .footer-right {
            text-align: center;
        }

        .footer {
            padding: 40px 15px 20px;
        }

        .table-header,
        .table-row-details,
        .table-row {
            height: auto;
        }

        .th, .tr,
        .table-wrapper3 .th.th-first,
        .table-wrapper3 .tr.tr-first {
            width: 50%;
            text-align: left;
            padding-left: 5px;
            float: none;
            display: inline-block;
        }

        .tr.tr-first,
        .th.th-first,
        .th.th-first-monthly,
        .tr.tr-first-monthly {
            width: 100%;
        }

        .mobile-bold {
            font-weight: bold;
            margin-top: 30px;
            border-bottom: 1px solid #B6B6B6;
            border-top: 1px solid #B6B6B6;
        }

        .subtotal-row3 {
            padding: 20px 0;
            border-top: 1px solid #B6B6B6;
        }

        .subtotal-row2 {
            border-bottom: 1px solid #B6B6B6;
            border-top: 1px solid #B6B6B6;
            padding: 25px 0;
            margin-top: 0;
        }

        .monthly-details {
            padding: 0 15px;
        }

        .vat-info {
            margin-top: 50px;
            text-align: left;
            padding: 0 15px;
        }

        .invoice-details-wrapper {
            position: relative;
        }

        .back-invoice {
            top: 0;
        }

        .no-data {
            padding-top: 130px;
            text-align: center;
        }
    }
</style>
